export const UserAuthenticationEndPoint = {
  LOGIN: "api/element/users/login",
  SIGNUP: "api/element/users/signup",
  CREATE_USER: "api/element/users/create-user",
  FORGOT_PASSWORD: "api/element/users/forgot-password",
  RESET_PASSWORD: "api/element/users/reset-password",
  GET_ALL_USERS: "api/element/users",
  ME: "api/element/users/me",
  DELETE_RECRUITER: "api/element/users/delete-recruiter",
  AUTHENTICATE: "api/element/users/authenticate",
  LOGOUT: "api/element/users/logout",
  CHANGE_PASSWORD: "api/element/users/change-password",
  DISABLE_FIRST_LOGIN: "api/element/users/disable-first-login",
  EDIT_USER: "api/element/users/edit-user",
};

export const ScheduleInterviewEndPoint = {
  SCHEDULE_INTERVIEW: "api/element/interview/schedule-interview",
  GET_ALL_INTERVIEW_SCHEDULE: "api/element/interview/get-all-combined-interviews",
  VALIDATE_INTERVIEW_SCHEDULE: "api/element/interview/validate-interview",
  SEND_INTERVIEW_OTP: "api/element/interview/send-otp",
  SUBMIT_INTERVIEW: "api/element/question_and_answer/create-conclusion",
  GENERATE_INTERVIEW_QUESTIONS:
    "api/element/question_and_answer/generate-interview-questions",
  UPLOAD_AUDIO: "api/element/file/uploadAudio",
  UPDATE_INTERVIEW: "api/element/interview/update-interview",
  EDIT_SCHEDULE_INTERVIEW: "api/element/interview/get-interview",
  CANCEL_INTERVIEW: "api/element/interview/cancel-interview",
  CHECK_CANDIDATE_EMAIL: "api/element/interview/check-candidate-email",
  GET_CANDIDATE_REPORT: "api/element/question_and_answer/download-report",
  GET_ALL_INTERVIEW_REPORTS: "api/element/interview/get-all-interview-reports",
  BLOCKED_INTERVIEW: "api/element/interview/block-interview",
};

export const PythonTopResumeAndMatch = {
  UPLOAD_JD_AND_RESUMES: "upload-jd-and-resumes",
  MATCH_ALL_RESUMES: "run-matching-process-all-resumes",
  MATCH_TOP_RESUMES: "run-matching-process-top-resumes",
  CREATE_NEW_JD: "generate-job-description",
  GET_DETAILDED_RESUME: "get-detailed-resume",
  DOWNLOAD_MATCHING_RESULTS: "download-matching-results",
  UPLOAD_RESPONSE_VIDEO: "upload-reference-video",
};

export const RoleEndPoint = {
  CREATE_ROLE: "api/element/role/create-role",
  GET_ALL_ROLES: "api/element/role/get-all-roles",
};

export const ExternalApiEndPoint = {
  COUNTRIES_CITIES: "https://countriesnow.space/api/v0.1/countries/cities",
  FLAG_CDN: "https://flagcdn.com/w40",
};

export const ScheduleProgrammingTestEndPoint = {
  SCHEDULE_PROGRAMMING_TEST:
    "api/element/programming_test/schedule-programming-test",
  GET_ALL_PROGRAMMING_TEST:
    "api/element/programming_test/get-all-programming-test",
  VALIDATE_PROGRAMMING_TEST:
    "api/element/programming_test/validate-programming-test",
  SEND_PROGRAMMING_TEST_OTP:
    "api/element/programming_test/send-otp",
  UPDATE_PROGRAMMING_TEST:
    "api/element/programming_test/update-programming-test",
  GET_PROGRAMMING_TEST: "api/element/programming_test/get-programming-test",
  CANCEL_PROGRAMMING_TEST: "api/element/programming_test/cancel-test",
  BLOCK_PROGRAMMING_TEST: "api/element/programming_test/block-test",
  SUBMIT_PROGRAMMING_TEST:
    "api/element/programming_question_and_answer/create-test-conclusion",
  DOWNLOAD_TEST_REPORT:
    "api/element/programming_question_and_answer/download-test-report",
};

export const PythonCodingTestEndPoint = {
  VERIFY_FACE_VIDEO: "coding-verify-face-video",
};

export const JobEndPoint = {
  GET_ALL_JOBS: "api/element/jobs",
  CREATE_JOB: "api/element/jobs",
  GET_NEXT_JOB_ID: "api/element/jobs/next-id",
  ASSIGN_USERS: "api/element/jobs/assign-users",
  SEARCH_ACTIVE_JOBS: "api/element/jobs/search-active",
  GET_JD_FILE: "api/element/jobs",
};

export const SavedCandidateEndPoint = {
  SAVE_CANDIDATES: "api/element/saved-candidates",
  GET_SAVED_CANDIDATES: "api/element/saved-candidates",
  GET_GROUPED: "api/element/saved-candidates/grouped",
  GET_BY_ID: "api/element/saved-candidates",
  UPDATE: "api/element/saved-candidates",
  GET_RESUME_URL: "api/element/saved-candidates/resume-url",
  DOWNLOAD_RESUME: "api/element/saved-candidates/download-resume",
  MOVE_CANDIDATES: "api/element/saved-candidates/move",
};

export const FinalShortlistedEndPoint = {
  SHORTLIST: "api/element/final-shortlisted",
  GET_ALL: "api/element/final-shortlisted",
  UPDATE: "api/element/final-shortlisted",
};

export const CompanyEndPoint = {
  GET_ALL_COMPANIES: "api/element/companies",
  CREATE_COMPANY: "api/element/companies",
  DELETE_COMPANY: "api/element/companies",
};

export const CustomQuestionEndPoint = {
  CREATE_CUSTOM_QUESTION: "api/element/custom-question",
  GET_CUSTOM_QUESTIONS_BY_ROLE: "api/element/custom-question",
  UPDATE_CUSTOM_QUESTION: "api/element/custom-question/question",
  DELETE_CUSTOM_QUESTION: "api/element/custom-question/question",
};
